/**
 * @ignore
 * Created by daletan on 6/29/16.
 */

'use strict';

const lodashGet = require('lodash.get');
const endpoints = require('dibs-endpoints');
const User = require('../models/User');
const currencyActions = require('./currencyActions');
const measurementActions = require('./measurementActions.es').default;
const tradeMessageActions = require('./tradeMessageActions');

function loadUserRelationship({ types, fieldsUserB }) {
    const url = `${endpoints.userRelationships()}?${
        User.COOKIE_USER
    }=${User.getUserToken()}&usersA=${User.getUserId()}&types=${types}&fieldsUserB=${fieldsUserB}`;

    return fetch(url)
        .then(response => response.json())
        .then(({ result }) => {
            const salesRep = lodashGet(result, '0.userDataB.0', null);
            return salesRep;
        });
}

const loginActions = {
    ACTION_LOGGED_OUT_USER: 'user:loggedOut',
    ACTION_FULL_PROFILE: 'user:fullProfile:loaded',
    ACTION_NET_PRICE: 'user:netPriceStatus',
    ACTION_SOCIAL_NETWORKS: 'user:socialNetworks:load',
    ACTION_TRADE_SALES_REP: 'user:trade:salesRep:load',
    ACTION_VIP_SALES_REP: 'user:vip:salesRep:load',

    handleLoginChange: actionContext => {
        return Promise.all([
            actionContext.executeAction(loginActions.loadFullUser),
            actionContext.executeAction(loginActions.loadTradeUserRepresentative),
            actionContext.executeAction(loginActions.getTradeUserCreateDate),
            actionContext.executeAction(loginActions.loadVipUserRepresentative),
            actionContext.executeAction(loginActions.checkUserTypeStatus),
            actionContext.executeAction(loginActions.getUserSocialNetworks),
            actionContext.executeAction(currencyActions.loadCurrencyForUser),
            actionContext.executeAction(measurementActions.loadMeasurementUnitForUser),
        ]);
    },

    loadLoggedOutUser: actionContext => {
        return Promise.resolve(User.load())
            .then(() => {})
            .catch(() => {})
            .then(profile => {
                actionContext.dispatch(loginActions.ACTION_LOGGED_OUT_USER, { profile });
            });
    },

    loadFullUser: actionContext => {
        return Promise.resolve(User.load())
            .then(profile => {
                actionContext.dispatch(loginActions.ACTION_FULL_PROFILE, {
                    profile,
                    isLoggedIn: true,
                });
                return profile;
            })
            .catch(profile => {
                if (profile.type && profile.type === 'NOT_LOGGED_IN') {
                    actionContext.dispatch(loginActions.ACTION_LOGGED_OUT_USER, { profile });
                    return;
                }
                actionContext.dispatch(loginActions.ACTION_FULL_PROFILE, { profile });
            });
    },

    checkUserTypeStatus: actionContext => {
        return Promise.resolve(User.load())
            .then(() => {
                const userCanRequestNetPrice = User.canRequestNetPrice();
                actionContext.dispatch(loginActions.ACTION_NET_PRICE, { userCanRequestNetPrice });
            })
            .catch(() => {
                actionContext.dispatch(loginActions.ACTION_NET_PRICE, {
                    userCanRequestNetPrice: false,
                });
            });
    },

    getUserSocialNetworks: actionContext => {
        return Promise.resolve(User.load())
            .then(() => {
                const socialNetworks = User.getCurrentUser().get('socialNetworks');
                actionContext.dispatch(loginActions.ACTION_SOCIAL_NETWORKS, { socialNetworks });
            })
            .catch(() => {
                // User.load() rejects if user is not logged in
            });
    },

    loadTradeUserRepresentative: actionContext => {
        return Promise.resolve(User.load())
            .then(() => {
                const isVerifiedTradeBuyer = User.getCurrentUser().isVerifiedTradeBuyer();

                if (isVerifiedTradeBuyer) {
                    return loadUserRelationship({
                        types: 'TRADE_SALES_REP',
                        fieldsUserB: 'TRADE_REP_PROFILE',
                    })
                        .then(salesRep => {
                            const tradeSalesRep = salesRep;
                            return actionContext
                                .executeAction(tradeMessageActions.checkTradeMessage, {
                                    tradeSalesRep,
                                })
                                .then(() => ({ tradeSalesRep }));
                        })
                        .then(({ tradeSalesRep }) => {
                            actionContext.dispatch(loginActions.ACTION_TRADE_SALES_REP, {
                                tradeSalesRep,
                            });
                            return tradeSalesRep;
                        });
                }

                return Promise.resolve();
            })
            .catch(() => {
                // User.load() rejects if user is not logged in
            });
    },

    getTradeUserCreateDate: () => {
        return Promise.resolve(User.load())
            .then(() => {
                const user = User.getCurrentUser();

                if (user.isVerifiedTradeBuyer()) {
                    const tradeRole = user
                        .get('roles')
                        .toJSON()
                        .find(({ name }) => name === User.BUYER_TRADE);
                    return tradeRole.createdDate;
                }

                return null;
            })
            .catch(() => {
                // User.load() rejects if user is not logged in
            });
    },

    loadVipUserRepresentative: actionContext => {
        return Promise.resolve(User.load())
            .then(() => {
                const isVipBuyer = User.getCurrentUser().isVipBuyer();

                if (isVipBuyer) {
                    return loadUserRelationship({
                        types: 'VIP_SALES_REP',
                        fieldsUserB: 'VIP_REP_PROFILE',
                    }).then(salesRep => {
                        const vipSalesRep = salesRep;
                        actionContext.dispatch(loginActions.ACTION_VIP_SALES_REP, { vipSalesRep });
                        return vipSalesRep;
                    });
                }

                return Promise.resolve();
            })
            .catch(() => {
                // User.load() rejects if user is not logged in
            });
    },
};

module.exports = loginActions;



// WEBPACK FOOTER //
// ./assets/js/global/actions/loginActions.es.js